<div id="cabecalho" class="container-fluid">
  <fieldset class="panel mb-1 mt-1">

    <div class="row">
      <div class="col-md-4">
        <div class="mb-1">
          <label for="nomePacienteFiltro" class="form-label">Nome do Paciente</label>
          <input type="text" class="form-control form-control-sm" id="nomePacienteFiltro" [(ngModel)]="nomePaciente">
        </div>
      </div>

      <div class="col-md-2">
        <div class="mb-1">
          <label for="dtNascimento" class="form-label">Dt. de Nascimento</label>
          <input type="date" class="form-control form-control-sm" id="dtNascimento" [(ngModel)]="dtNascimento">
        </div>
      </div>

      <div class="col-md-1">
        <div class="mb-1">
          <label for="dtAtendimento" class="form-label">Dt. do ATD.</label>
          <input type="date" class="form-control form-control-sm" id="dtAtendimento" [(ngModel)]="dtAtendimento">
        </div>
      </div>

      <div class="col-md-2">
        <div class="mb-1">
          <label for="cpfFiltro" class="form-label">CPF</label>
          <input type="text" class="form-control form-control-sm" id="cpfFiltro" [(ngModel)]="cpf">
        </div>
      </div>

      <div class="col-md-2">
        <div class="mb-1">
          <button class="btn btn-sm btn-secondary w-100" (click)="filtrar(myModal)">Pesquisa Prontuário</button>
          <button class="btn btn-sm btn-secondary w-100" (click)="fechaProntuario()">Fecha Prontuário</button>
        </div>
      </div>

    </div>

    <div class="row">

      <div class="col-md-4">
        <div class="mb-1">
          <button class="btn btn-sm btn-secondary w-50" (click)="limpaCampos();">Limpa Campos</button>
        </div>
      </div>

      <div class="col-md-8">
        <div class="mb-1">
          <div class="form-check">
            <input class="form-check-input" type="checkbox" [(ngModel)]="medicoSelecionado" id="medicoSelecionado">
            <label class="form-check-label" for="medicoSelecionado">
              Apenas pacientes do Dr(a). {{ medico?.nome }}
            </label>
          </div>
        </div>
      </div>
    </div>

    <hr>

    <div id="cabecalho" class="container-fluid">
      <fieldset class="panel mb-1">
        <legend>Dados do Atendimento</legend>
        <hr>
        <div class="row">

          <div class="col-md-5">
            <div class="mb-1">
              <label for="nomePaciente" class="form-label">Nome do Paciente</label>
              <input type="text" class="form-control form-control-sm" id="nomePaciente" readonly
                     [value]="prontuarioAtual?.beneficiario?.nome_Beneficiario">
            </div>
          </div>

          <div class="col-md-1">
            <div class="mb-1">
              <label for="nroAtd" class="form-label">Código</label>
              <input type="text" class="form-control form-control-sm" id="nroAtd" readonly
                     [value]="prontuarioAtual?.seq_Agenda">
            </div>
          </div>

          <div class="col-md-1">
            <div class="mb-1">
              <label for="seq_Beneficiario" class="form-label">Prontuário</label>
              <input type="text" class="form-control form-control-sm" id="seq_Beneficiario" readonly
                     [value]="prontuarioAtual?.seq_Beneficiario">
            </div>
          </div>
        </div>
        <div class="row">

          <div class="col-md-2">
            <div class="mb-1">
              <label for="dataNascimento" class="form-label">Dt. Nascimento</label>
              <input type="text" class="form-control form-control-sm" id="dataNascimento" readonly
                     [value]="prontuarioAtual?.beneficiario?.data_Nascimento | date: 'dd/MM/yyyy'">
            </div>
          </div>

          <div class="col-md-2">
            <div class="mb-1">
              <label for="birthdate" class="form-label">Idade</label>
              <input type="text" class="form-control form-control-sm" id="birthdate" readonly
                     [value]="prontuarioAtual?.beneficiario?.data_Nascimento | idade">
            </div>
          </div>

          <div class="col-md-2">
            <div class="mb-1">
              <label for="cpf" class="form-label">CPF</label>
              <input type="text" class="form-control form-control-sm" id="cpf" readonly
                     [value]="prontuarioAtual?.beneficiario?.cpf">
            </div>
          </div>

          <div class="col-md-2">
            <div class="mb-1">
              <label for="plano" class="form-label">Plano</label>
              <input type="text" class="form-control form-control-sm" id="plano" readonly
                     value="{{ prontuarioAtual?.plano?.descricao_Plano_Operadora ?? 'PARTICULAR' }}">
            </div>
          </div>

          <div class="col-md-2">
            <div class="mb-1">
              <label for="estado_Civil" class="form-label">Estado Civil</label>
              <input type="text" class="form-control form-control-sm" id="estado_Civil" readonly
                     value="{{ prontuarioAtual?.beneficiario?.estado_Civil ?? '--' }}">
            </div>
          </div>

          <div class="col-md-2">
            <div class="mb-1">
              <label for="operadora" class="form-label">Operadora</label>
              <input type="text" class="form-control form-control-sm" id="operadora" readonly value="{{ prontuarioAtual?.plano?.operadora?.nome_Operadora ?? 'PARTICULAR' }}">
            </div>
          </div>

          <div class="col-md-4">
            <div class="mb-1">
              <label for="endereco" class="form-label">Endereço</label>
              <input type="text" class="form-control form-control-sm" id="endereco" readonly value="{{ prontuarioAtual?.beneficiario?.endereco ?? '--' }}">
            </div>
          </div>

          <div class="col-md-2">
            <div class="mb-1">
              <label for="bairro" class="form-label">Bairro</label>
              <input type="text" class="form-control form-control-sm" id="bairro" readonly value="{{ prontuarioAtual?.beneficiario?.bairro ?? '--' }}">
            </div>
          </div>

          <div class="col-md-2">
            <div class="mb-1">
              <label for="municipio" class="form-label">Município</label>
              <input type="text" class="form-control form-control-sm" id="municipio" readonly value="{{ prontuarioAtual?.beneficiario?.cod_Municipio ?? '--' }}">
            </div>
          </div>

          <div class="col-md-1">
            <div class="mb-1">
              <label for="uf" class="form-label">UF</label>
              <input type="text" class="form-control form-control-sm" id="uf" readonly value="{{ prontuarioAtual?.beneficiario?.sigla_UF ?? '--' }}">
            </div>
          </div>

          <div class="col-md-1">
            <div class="mb-1">
              <label for="cep" class="form-label">CEP</label>
              <input type="text" class="form-control form-control-sm" id="cep" readonly value="{{ prontuarioAtual?.beneficiario?.cep ?? '--' }}">
            </div>
          </div>

        </div>

        <div class="row">

          <div class="col-md-4">
            <div class="mb-1">
              <label for="nome_Mae" class="form-label">Nome da Mãe</label>
              <input type="text" class="form-control form-control-sm" id="nome_Mae" readonly
                     value="{{ prontuarioAtual?.beneficiario?.nome_Mae }}">
            </div>
          </div>

          <div class="col-md-4">
            <div class="mb-1">
              <label for="nome_Pai" class="form-label">Nome do Pai</label>
              <input type="text" class="form-control form-control-sm" id="nome_Pai" readonly
                     value="{{ prontuarioAtual?.beneficiario?.nome_Pai }}">
            </div>
          </div>

          <div class="col-md-2">
            <div class="mb-1">
              <label for="telefone" class="form-label">Telefone</label>
              <input type="text" class="form-control form-control-sm" id="telefone" readonly value="{{ prontuarioAtual?.beneficiario?.telefone ?? '--' }}">
            </div>
          </div>

          <div class="col-md-2">
            <div class="mb-1">
              <label for="celular" class="form-label">Celular</label>
              <input type="text" class="form-control form-control-sm" id="celular" readonly value="{{ prontuarioAtual?.beneficiario?.telefone_Celular ?? '--' }}">
            </div>
          </div>

        </div>
      </fieldset>

      <div class="row">
        <div class="col-md-10">
          <div class="panel">
            <legend>Profissional Executante</legend>
            <div class="row">

              <div class="col-md-1">
                <div class="mb-1">
                  <label for="tipoConselho" class="form-label">Conselho</label>
                  <input type="text" class="form-control form-control-sm" id="tipoConselho" readonly value="{{ tipoConselho }}">
                </div>
              </div>

              <div class="col-md-2">
                <div class="mb-1">
                  <label for="numConselho" class="form-label">Número</label>
                  <input type="text" class="form-control form-control-sm" id="numConselho" readonly value="{{ prontuarioAtual?.corpoClinico?.profissional?.num_Conselho }}">
                </div>
              </div>

              <div class="col-md-1">
                <div class="mb-1">
                  <label for="ufConselho" class="form-label">UF</label>
                  <input type="text" class="form-control form-control-sm" id="ufConselho" readonly value="{{ prontuarioAtual?.corpoClinico?.profissional?.sigla_UF }}">
                </div>
              </div>

              <div class="col-md-5">
                <div class="mb-1">
                  <label for="nomeProfissional" class="form-label">Nome do Profissional</label>
                  <input type="text" class="form-control form-control-sm" id="nomeProfissional" readonly
                    value="{{ prontuarioAtual?.corpoClinico?.profissional?.nome }}">
                </div>
              </div>

              <div class="col-md-3">
                <div class="mb-1">
                  <label for="especialidade" class="form-label">Clínica</label>
                  <input type="text" class="form-control form-control-sm" id="especialidade" readonly value="{{ especialidade?.descricao_Clinica }}">
                </div>
              </div>

            </div>
          </div>
        </div>

      </div>
    </div>
<div class="row mt-3" [hidden]="!prontuarioAtual">
  
  <div class="col-md-4">
    <app-tabela-consulta></app-tabela-consulta>
  </div>

  <div class="col-md-8">
    <ul class="nav nav-tabs mb-2" style="cursor: pointer;">
      <li class="nav-item">
        <a class="nav-link" [class.active]="abaAtivaMenu === 'prescricao'" (click)="mudarAbaMenu('prescricao')">
          Prescrição
        </a>
      </li>
      <li class="nav-item">
        <a class="nav-link" [class.active]="abaAtivaMenu === 'evolucao'" (click)="mudarAbaMenu('evolucao')">
          Evolução
        </a>
      </li>
      <li class="nav-item">
        <a class="nav-link" [class.active]="abaAtivaMenu === 'exames'" (click)="mudarAbaMenu('exames')">
          Pedidos de Exame
        </a>
      </li>
      <li class="nav-item">
        <a class="nav-link" [class.active]="abaAtivaMenu === 'encaminhamento'" (click)="mudarAbaMenu('encaminhamento')">
          Encaminhamento
        </a>
      </li>
      <li class="nav-item">
        <a class="nav-link" [class.active]="abaAtivaMenu === 'atestados'" (click)="mudarAbaMenu('atestados')">
          Atestados
        </a>
      </li>
    </ul>

    <div class="tab-content border p-3 rounded bg-white" style="min-height: 400px;">
      <div [hidden]="abaAtivaMenu !== 'prescricao'">
        <app-prescricao></app-prescricao>
      </div>
      
      <div [hidden]="abaAtivaMenu !== 'evolucao'">
        <app-evolucao></app-evolucao>
      </div>
      
      <div [hidden]="abaAtivaMenu !== 'exames'">
        <app-exames></app-exames>
      </div>
      
      <div [hidden]="abaAtivaMenu !== 'encaminhamento'">
        <app-encaminhamento></app-encaminhamento>
      </div>
      
      <div [hidden]="abaAtivaMenu !== 'atestados'">
        </div>
    </div>
  </div>

</div>


    <ng-template #myModal let-modal>
      <div class="modal-content">
        <div class="modal-header">
          <h4 class="modal-title">Resultado da Pesquisa</h4>
          <button type="button" class="close" (click)="modal.dismiss('Cross click')">
            <span>&times;</span>
          </button>
        </div>
        <div class="modal-body">
          <div class="table-responsive">
            <table class="table table-sm table-striped table-hover">
              <thead>
              <tr>
                <th scope="col">Data</th>
                <th scope="col">Hora</th>
                <th scope="col">Nome do Beneficiário</th>
                <th scope="col">Ação</th>
              </tr>
              </thead>
              <tbody>
              <tr *ngFor="let prontuario of prontuarios">
                <td>{{ prontuario.data_Agenda | date: 'dd/MM/yyyy' }}</td>
                <td>{{ prontuario.hora_Agenda | numeroParaHora }}</td>
                <td>{{ prontuario.beneficiario?.nome_Beneficiario }}</td>
                <td><button type="button" class="btn btn-sm btn-primary" (click)="selecionarProntuario(prontuario); modal.dismiss('Cross click')">Selecionar</button></td>
              </tr>
              </tbody>
            </table>
          </div>
        </div>
        <div class="modal-footer">
          <button type="button" class="btn btn-secondary" (click)="modal.close('Fechar')">Fechar</button>
        </div>
      </div>
    </ng-template>





  </fieldset>
</div>
